import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(public)/technologies/Item.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(public)/technologies/styles.css");
